import React from 'react';
import { Bot } from 'lucide-react';

export const Tab = ({ active, onClick, children, icon: Icon }) => (
  <button
    onClick={onClick}
    className={`flex items-center gap-1.5 px-3 py-3 font-medium transition-all border-b-2 whitespace-nowrap text-xs sm:text-sm flex-shrink-0 ${
      active 
        ? 'text-blue-400 border-blue-400 bg-blue-500/10' 
        : 'text-gray-400 border-transparent hover:text-gray-300 hover:bg-gray-800/50'
    }`}
  >
    {Icon && <Icon size={14} className="flex-shrink-0" />}
    <span>{typeof children === 'string' ? children : children}</span>
  </button>
);

// Card de Estatística
export const StatCard = ({ title, value, icon: Icon, color = 'blue', subtitle }) => (
  <div className="bg-gray-800/50 rounded-xl p-4 border border-gray-700/50">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-400 text-sm">{title}</p>
        <p className={`text-2xl font-bold text-${color}-400`}>{value}</p>
        {subtitle && <p className="text-gray-500 text-xs mt-1">{subtitle}</p>}
      </div>
      <div className={`p-3 rounded-lg bg-${color}-500/20`}>
        <Icon className={`text-${color}-400`} size={24} />
      </div>
    </div>
  </div>
);

// Badge de Status
export const StatusBadge = ({ status }) => {
  const styles = {
    new: 'bg-gray-500/20 text-gray-300',
    contacted: 'bg-blue-500/20 text-blue-300',
    qualified: 'bg-yellow-500/20 text-yellow-300',
    interested: 'bg-purple-500/20 text-purple-300',
    converted: 'bg-green-500/20 text-green-300',
    rejected: 'bg-red-500/20 text-red-300',
    bot_detected: 'bg-orange-500/20 text-orange-300',
    draft: 'bg-gray-500/20 text-gray-300',
    active: 'bg-green-500/20 text-green-300',
    paused: 'bg-yellow-500/20 text-yellow-300',
    completed: 'bg-blue-500/20 text-blue-300'
  };

  const labels = {
    new: 'Novo',
    contacted: 'Contatado',
    qualified: 'Qualificado',
    interested: 'Interessado',
    converted: 'Convertido',
    rejected: 'Rejeitado',
    bot_detected: 'Bot Detectado',
    draft: 'Rascunho',
    active: 'Ativa',
    paused: 'Pausada',
    completed: 'Concluída'
  };

  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${styles[status] || styles.new}`}>
      {labels[status] || status}
    </span>
  );
};

// ==================== COMPONENTE PRINCIPAL ====================

